import { render, staticRenderFns } from "./InputCode.vue?vue&type=template&id=1c65d23a&"
import script from "./InputCode.vue?vue&type=script&lang=ts&"
export * from "./InputCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports